module.exports = __webpack_public_path__ + "img/recolumn_example9.04057661.png";